import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Grid, Box } from '@mui/material';
import { CompanyAssociationInfoRequestModel, ECompanyOrAssociationType, PrivateUserInfoRequestModel, UserInfosModel } from '../../models/user/UserInfosModel';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import TextFieldCustom from '../TextField/TextFieldCustom';
import SearchNations from './searchNation';
import DatePickerCustom from '../DatePicker/DatePickerCustom';
import dayjs, { Dayjs } from 'dayjs';
import lastDate18YearsAgo from '../../utilities/lastDate18YearsAgo';
import { BLUE_DARK, GRAY_LIGHT, GRAY_MAIN, GREEN_LOGO, GREEN_MAIN, WHITE } from '../../theme/colors';
import { putMeAssociationOrCompany, putMePrivate } from '../../hooks/actions/users';
import AlertSaveModal from './AlertSaveModal';
import { useWaiter } from '../../hooks/waiter/WaiterProvider';
import { Snackbar, Alert } from '@mui/material';
import Link from '@mui/material/Link';
import { ESex } from '../../hooks/auth/models';
import SexSelect from './DropDownSex';
import MarketFormEmbedded from '../Markets/MarketFormEmbedded';
import { addNewActivity, myMarketsList } from '../../hooks/actions/market';
import { LegacyMarket } from '../../models/market/LegacyMarket';
import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import { useUserContext } from '../../hooks/auth/UserProvider';

interface CompanyOrAssociationUserProps {
  user: UserInfosModel; 
  type?: ECompanyOrAssociationType
}

const StyledListItem = styled(ListItem)(({ theme }) => ({
  '&.Mui-selected': {
    backgroundColor: `${GREEN_MAIN}20`,
    '&:hover': {
      backgroundColor: `${GREEN_MAIN}30`,
    },
  },
  '&:hover': {
    backgroundColor: `${GREEN_MAIN}30`,
  },
}));

const AssociationOrCompanyUser: React.FC<CompanyOrAssociationUserProps> = ({ user, type }) => {
  const { t } = useTranslationContext();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState<CompanyAssociationInfoRequestModel>({
    userId: user.userId || '', 
    isPrivate: user.isPrivate,
    conventioned: user.conventioned,
    email: user.email,
    enabledUser: user.enabledUser === true,
    username: user.username,
    userType: user.userType,
    refCode: user.refCode || '',
    association: user.association || '',
    companyOrAssociationStatus: user.companyOrAssociationStatus || 0,
    
    userInfoId: user.companyAssociationInfo?.id || '',

    // Dati relativi all'amministratore aziendale
    nome: user.companyAssociationInfo?.nome || '',
    cognome: user.companyAssociationInfo?.cognome || '',
    born: user.companyAssociationInfo?.born || undefined,
    address: user.companyAssociationInfo?.address || '', // RIMOSSO
    comuneDiNascita: user.companyAssociationInfo?.comuneDiNascita || '',
    statoDiNascita: user.companyAssociationInfo?.statoDiNascita || '',
    city: user.companyAssociationInfo?.city || '', // RIMOSSO
    cap: user.companyAssociationInfo?.cap || 0, // RIMOSSO
    provincia: user.companyAssociationInfo?.provincia || '', // RIMOSSO
    nation: user.companyAssociationInfo?.nation || '', // RIMOSSO
    codiceFiscale: user.companyAssociationInfo?.codiceFiscale || '',
    telephone: user.telephone || '',

    // Dati relativi all'azienda
    nomeAziendaAssociazione: user.companyAssociationInfo?.nomeAziendaAssociazione || '',
    addressSedeLegale: user.companyAssociationInfo?.addressSedeLegale || '',
    citySedeLegale: user.companyAssociationInfo?.citySedeLegale || '',
    capSedeLegale: user.companyAssociationInfo?.capSedeLegale,
    nationSedeLegale: user.companyAssociationInfo?.nationSedeLegale || '',
    provinciaSedeLegale: user.companyAssociationInfo?.provinciaSedeLegale || '',
    partitaIvaVat: user.companyAssociationInfo?.partitaIvaVat,
    codiceFiscaleAziendale: user.companyAssociationInfo?.codiceFiscaleAziendale || '',
    websiteAziendale: user.companyAssociationInfo?.websiteAziendale,
    telefonoAziendale: user.companyAssociationInfo?.telefonoAziendale,
    mailRichiestePubblicheAziendale: user.companyAssociationInfo?.mailRichiestePubblicheAziendale,
    websiteSottoscrizioneAssociazioni: user.companyAssociationInfo?.websiteSottoscrizioneAssociazioni,
    //socialLink: user.companyAssociationInfo?.socialLink,
    sex: user.companyAssociationInfo?.sex || ESex.Male
  });
  const [legacyMarkets, setLegacyMarkets] = useState<LegacyMarket[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const {setWaiterView} = useWaiter();
  const [initialFormData, setInitialFormData] = useState({ ...formData }); // Salva i dati iniziali

  const [modalOpen, setModalOpen] = useState(false);
  const bornDate = initialFormData.born ? dayjs(initialFormData.born) : dayjs("01-01-1900")
  const [selectedDate, setSelectedDate] = useState<Dayjs | undefined>(bornDate); 
  const [bornError, setBornError] = useState(false);
  const [bornErrorMessage, setBornErrorMessage] = useState('');
  const [maxData] = useState<Dayjs | undefined>(dayjs(lastDate18YearsAgo()));

  const [numeroSediOperative, setNumeroSediOperative] = useState<number>(user?.numeroSediOperative ?? 0);

  const [mainError, setMainError] = useState<boolean>(false);
  const [mainErrorMex, setMainErrorMex] = useState<string>("");

  const [marketData, setMarketData] = useState<any>(null);

  const {isForbidden} = useUserContext();

  useEffect(() => {
    if (user) {
      
      setNumeroSediOperative(user.numeroSediOperative ?? 0);
    }
  }, [user]);

  useEffect(() => {
    myMarketsList().then((resp) => {
        setLegacyMarkets(resp);
        
    }).catch(error => {
      // Gestisci eventuali errori qui
      console.error(error)
    });
  }, [numeroSediOperative, user]);

  const handleChange = (value: string, key: string) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value, // Directly update with the string value
    }));
  };

  const handleEdit = () => {
    setMainError(false); // cancello eventuali errori
    setMainErrorMex("");

    setIsEditing(true);
  };

  const handleSave = () => {
    setMainError(false);
    setMainErrorMex("");
    handleCloseModal();

    const hasUserDataChanges = JSON.stringify(formData) !== JSON.stringify(initialFormData);
    const hasMarketData = marketData && marketData.marketName;

    if (!hasUserDataChanges && !hasMarketData) {
      setIsEditing(false);
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 10000);
      return;
    }

    setWaiterView(true);
    
    let savePromise;
    if (hasMarketData) {
      
      savePromise = addNewActivity(marketData)
        .then(() => {
          const newNumSedi = numeroSediOperative + 1;
          
          setNumeroSediOperative(newNumSedi);
          if (hasUserDataChanges) {
            return putMeAssociationOrCompany(formData);
          }
          return null;
        });
    } else {
      
      if (hasUserDataChanges) {
        savePromise = putMeAssociationOrCompany(formData);
      } else {
        savePromise = Promise.resolve();
      }
    }
    
    savePromise
      .then(resp => {
        if (resp) {
          setFormData(resp);
          setInitialFormData(resp);
        }
        setWaiterView(false);
        
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 10000);
      })
      .catch(error => {
        setMainError(true);
        const errorMex = error?.response?.data?.title || 
                        error?.response?.data?.message || 
                        error?.response?.data || 
                        error?.response || 
                        t("Errore durante la modifica dei dati")
        setMainErrorMex(errorMex);
        setWaiterView(false);
      });

    setIsEditing(false);
  };

  const handleCancel = () => {
    setMainError(false); // cancello eventuali errori
    setMainErrorMex("");

    setFormData(initialFormData); // Reset dei dati al valore iniziale
    setIsEditing(false);
  };

  // Conditionally render the component output
  if (!user.userId) {
    return <div>{t("Utente non disponibile.")}</div>;
  }

  const handleChangeDate = (date: Dayjs | null) => {
    setBornErrorMessage('');

    if (date !== null && date.isValid()) {
      setSelectedDate(date);
      setBornError(false);

      if (maxData !== undefined && date.isAfter(maxData)) {
        setBornErrorMessage(t('Devi avere più di 18 anni per iscriverti'));
        setBornError(true);
      }

      // 🔧 Normalizza la data in formato UTC
      const normalized = new Date(Date.UTC(date.year(), date.month(), date.date()));

      setFormData((prev) => ({
        ...prev,
        born: normalized, // ora sarà "1977-02-01T00:00:00.000Z"
      }));
    }

    if (date !== null && !date.isValid()) {
      setBornErrorMessage(t('Data non valida'));
      setBornError(true);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  return (
    <Box
      width='100%'
    >
        <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
                mb: 8,
                mt:0,
                fontWeight: "bold",
                color: GREEN_MAIN
            }}
        >
            {t("Informazioni Utente")}
        </Typography>

        <form>
          <Box justifyItems='center'>            
            <Grid container xs={12} md={8} spacing={3} paddingBottom='100px'>
              
              {/** Subtitle dati */}
              <Grid item xs={12}>
                <Typography sx={{
                  padding:'14px 0px',
                  //color: 'rgb(139, 70, 111)',
                  color: GREEN_MAIN,
                  fontSize:'0.9rem',
                  textAlign: 'left',
                  width:'100%'
                }}>
                  {type && type === ECompanyOrAssociationType.Association ? t("Dati dell'Associazione") : t("Dati fiscali dell'attività economica")}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <TextFieldCustom
                  label={t("Denominazione")}
                  regex={ new RegExp("^[\\p{L}\\p{N}\\p{M}\\p{P}\\p{Z}\\p{S} \\-']+$", "u")}
                  value={formData.nomeAziendaAssociazione || ''}
                  errorText={t("Richieste lettere e spazi")}
                  onChange={(value) => handleChange(value, 'nomeAziendaAssociazione')}
                  disable={(!initialFormData.nomeAziendaAssociazione) && isEditing ? false : true}
                  required
                />
              </Grid>  

              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  label={t("Indirizzo")}
                  regex={ new RegExp("^[\\p{L}\\p{N}\\p{M}\\p{P}\\p{Z}\\p{S} ,\\.\\-\\/]+$", "u")}
                  value={formData.addressSedeLegale || ''}
                  onChange={(value) => handleChange(value, 'addressSedeLegale')}
                  required={true}
                  errorText={t("Richieste solo lettere, spazi, numeri, virgola e meno e /")}
                  disable={!isEditing}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  label={t("Città")}
                  regex={ new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")}
                  value={formData.citySedeLegale || ''}
                  onChange={(value) => handleChange(value, 'citySedeLegale')}
                  required={true}
                  errorText={t("Richieste lettere e spazi")}
                  disable={!isEditing}
                />
              </Grid>

              <Grid item xs={4} sm={3}>
                <TextFieldCustom
                  label={t("CAP")}
                  regex={/^[0-9]+$/}
                  value={formData.capSedeLegale === 0 || formData.capSedeLegale === undefined ? '' : formData.capSedeLegale.toString() }
                  onChange={(value) => handleChange(value, 'capSedeLegale')}
                  required={true}
                  errorText={t("Richiesti solo Numeri")}
                  disable={!isEditing}
                />
              </Grid>
              <Grid item xs={8} sm={4}>
                <TextFieldCustom
                  label={t("Provincia")}
                  regex={new RegExp("^[\\p{L} \\-']{2,50}$", "u")}
                  value={formData.provinciaSedeLegale || '' }
                  onChange={(value) => handleChange(value, 'provinciaSedeLegale')}
                  required={true}
                  errorText={t("Richieste solo Lettere")}
                  disable={!isEditing}
                  props={{
                    sx: {
                      '& .MuiOutlinedInput-notchedOutline': {
                          // borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root': {
                          top: -4,
                          fontSize: '1rem',
                          //color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                      },
                      '& .MuiOutlinedInput-input': {
                          padding: '12px 12px',
                          lineHeight: 1.4,
                          color: "grey",
                          fontSize: '1rem',
                          textTransform: 'uppercase'
                      },
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <SearchNations 
                  label={t("Stato")}
                  nazione={formData.nationSedeLegale || ''} 
                  setNazione={(value) => handleChange(value, 'nationSedeLegale')} 
                  disable={(!initialFormData.nationSedeLegale) && isEditing ? false : true}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextFieldCustom
                  label={t("E-mail")}
                  value={formData.email || '' }
                  errorText={t("")}
                  props={{
                    sx:{
                      '& .MuiOutlinedInput-input': {
                        textTransform: 'lowercase'
                      }
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextFieldCustom
                  label={t("E-mail (pubblica)")}
                  regex={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
                  value={formData.mailRichiestePubblicheAziendale || '' }
                  onChange={(value) => handleChange(value, 'mailRichiestePubblicheAziendale')}
                  errorText={t("Formato mail non corretto")}
                  disable={!isEditing}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldCustom
                  label={t("Telefono")}
                  regex={/^\+?[0-9\s\-()]{7,20}$/}
                  value={formData.telephone?.toString() || '' }
                  onChange={(value) => handleChange(value, 'telephone')}
                  required={false}
                  errorText={t("Richiesti solo Numeri")}
                  disable={!isEditing}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  label={t("Codice Fiscale")}
                  regex={/^[A-Za-z0-9]*$/}
                  value={formData.codiceFiscaleAziendale || '' }
                  onChange={(value) => handleChange(value, 'codiceFiscaleAziendale')}
                  required={true}
                  errorText={t("Richiesti lettere e numeri")}
                  disable={(!initialFormData.codiceFiscaleAziendale) && isEditing ? false : true}
                  props={{
                    sx: {
                      '& .MuiOutlinedInput-notchedOutline': {
                          // borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root': {
                          top: -4,
                          fontSize: '1rem',
                          //color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                      },
                      '& .MuiOutlinedInput-input': {
                          padding: '12px 12px',
                          lineHeight: 1.4,
                          color: "grey",
                          fontSize: '1rem',
                          textTransform: 'uppercase'
                      },
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  label={t("Partita Iva")}
                  regex={/^[A-Za-z0-9]*$/}
                  value={formData.partitaIvaVat || '' }
                  onChange={(value) => handleChange(value, 'partitaIvaVat')}
                  required={false}
                  errorText={t("Richiesti lettere e numeri")}
                  disable={(!initialFormData.partitaIvaVat) && isEditing ? false : true}
                  props={{
                    sx: {
                      '& .MuiOutlinedInput-notchedOutline': {
                          // borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root': {
                          top: -4,
                          fontSize: '1rem',
                          //color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                      },
                      '& .MuiOutlinedInput-input': {
                          padding: '12px 12px',
                          lineHeight: 1.4,
                          color: "grey",
                          fontSize: '1rem',
                          textTransform: 'uppercase'
                      },
                    }
                  }}
                />
              </Grid>

              {/*{
                type !== undefined && type === ECompanyOrAssociationType.Company && numeroSediOperative === 0
                ? 
                <></>
                :*/}
                <>
                  <Grid item xs={12} sm={6}>
                    <TextFieldCustom
                      label={t("Sito internet / pagina social")}
                      regex={/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/}
                      value={formData.websiteAziendale || '' }
                      onChange={(value) => handleChange(value, 'websiteAziendale')}
                      errorText={t("Formato sito web non corretto")}
                      disable={!isEditing}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextFieldCustom
                      label={t("Telefono (pubblico)")}
                      regex={/^\+?(\d{1,3})?[-. ]?\(?\d{1,4}\)?[-. ]?\d{1,4}[-. ]?\d{1,9}$/}
                      value={formData.telefonoAziendale || '' }
                      onChange={(value) => handleChange(value, 'telefonoAziendale')}
                      errorText={t("Formato telefonico non corretto")}
                      disable={!isEditing}
                    />
                  </Grid>
                </>
              
              
              { 
                type !== undefined && type === ECompanyOrAssociationType.Association && 
                <>
                  <Grid item xs={12}>
                    <TextFieldCustom
                      label={t("URL per eventuali iscrizioni")}
                      regex={/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/}
                      value={formData.websiteSottoscrizioneAssociazioni || '' }
                      onChange={(value) => handleChange(value, 'websiteSottoscrizioneAssociazioni')}
                      errorText={t("Formato sito web non corretto")}
                      disable={!isEditing}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    eventuale Form per inserimento parole chiave associazione
                  </Grid> */}
                </>
              }

              {
                type !== undefined && type === ECompanyOrAssociationType.Company && numeroSediOperative === 0 ? 
                  null :
                  type !== undefined && type === ECompanyOrAssociationType.Company && numeroSediOperative > 0 ?
                <>
                  {/** Se presente Sede lavorativa visualizzare questo bottone*/}
                  <Box sx={{
                    display: 'flex',
                    width:'100%',
                    justifyContent:'right',
                    padding:'18px 0'
                  }}>
                    <Link href={`/user/economics-activities`} variant="body2" sx={{
                        fontSize:'0.8em',
                        color: GREEN_MAIN,
                        textDecoration: 'none',
                        '&:hover': {
                            textDecoration: 'underline', 
                        },
                    }}>
                      {t("Gestisci le attività economiche")}
                    </Link>
                  </Box>
                </> 
                : null
              }

              {/** Subtitle dati */}
              <Grid item xs={12}>
                <Typography sx={{
                  padding:'50px 0px 14px 0px',
                  //color: 'rgb(139, 70, 111)',
                  color: GREEN_MAIN,
                  fontSize:'0.9rem',
                  textAlign: 'left',
                  width:'100%'
                }}>
                  { t("Dati del legale rappresentante") }
                </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  label={t("Nome")}
                  regex={new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")}
                  value={formData.nome || ''}
                  errorText={t("Richieste lettere e spazi")}
                  onChange={(value) => handleChange(value, 'nome')}
                  disable={!isEditing}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  label={t("Cognome")}
                  regex={new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")}
                  value={formData.cognome || ''}
                  errorText={t("Richieste lettere e spazi")}
                  onChange={(value) => handleChange(value, 'cognome')}
                  disable={!isEditing}
                  required
                />
              </Grid>

              <Grid item xs={4} sm={2} >
                <SexSelect 
                  value={formData.sex || ESex.Male}
                  onChange={(value) => handleChange(value, 'sex')}
                  disable={(!initialFormData.sex) && isEditing ? false : true} />
              </Grid>
              <Grid item xs={8} sm={4} >
                <DatePickerCustom
                  label={t("Data di Nascita")}
                  selectedDate={selectedDate}
                  handleChangeDate={handleChangeDate}
                  maxData={maxData}
                  error={bornError}
                  errorMessage={bornErrorMessage}
                  disable={!isEditing}
                  stackProps={{
                    sx: {
                      marginTop:0,
                      marginBottom:0,
                      '& .MuiOutlinedInput-notchedOutline': {
                          // borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root': {
                          top: -4,
                          fontSize: '1rem',
                          //color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                      },
                      '& .MuiOutlinedInput-input': {
                          padding: '12px 12px',
                          lineHeight: 1.4,
                          color: "grey",
                          fontSize: '1rem',
                      },
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  label={t("Codice Fiscale")}
                  regex={/^[A-Za-z0-9]*$/}
                  value={formData.codiceFiscale || '' }
                  onChange={(value) => handleChange(value, 'codiceFiscale')}
                  required={true}
                  errorText={t("Richiesti lettere e numeri")}
                  disable={!isEditing}
                  props={{
                    sx: {
                      '& .MuiOutlinedInput-notchedOutline': {
                          // borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root': {
                          top: -4,
                          fontSize: '1rem',
                          //color: GREEN_MAIN,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: GREEN_LOGO,
                          color: GREEN_MAIN,
                      },
                      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                      },
                      '& .MuiOutlinedInput-input': {
                          padding: '12px 12px',
                          lineHeight: 1.4,
                          color: "grey",
                          fontSize: '1rem',
                          textTransform: 'uppercase'
                      },
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={7}>
                <TextFieldCustom
                  label={t("Comune di nascita")}
                  regex={ new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")}
                  value={formData.comuneDiNascita || ''}
                  onChange={(value) => handleChange(value, 'comuneDiNascita')}
                  required={true}
                  errorText={t("Richieste lettere e spazi")}
                  disable={!isEditing}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <SearchNations 
                  label={t("Stato di nascita")}
                  nazione={formData.statoDiNascita || ''} 
                  setNazione={(value) => handleChange(value, 'statoDiNascita')} 
                  disable={!isEditing}
                />
              </Grid>
            </Grid>  


          </Box>
        </form>

        {!isForbidden && (
          !isEditing ? (
            <Grid container justifyContent="center" alignItems="center" spacing={3}>
              <Grid item xs={6} sm={4} md={2}>
                <Button variant="contained" color="info" onClick={handleEdit} sx={{
                  margin:"10px 0 0 0",
                  height: '35px',
                  color:WHITE,
                  backgroundColor: GREEN_LOGO,
                  "&:hover": { backgroundColor: "darkgreen" },
                  border: "1px solid " + GREEN_LOGO,
                }}>
                  {t("Modifica")}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container justifyContent="center" alignItems="center" spacing={1}>
              <Grid item xs={6} sm={4} md={2}>
                <Button variant="outlined" onClick={handleCancel} sx={{
                  margin:"10px 0 0 0",
                  height: '35px',
                  "&:hover": { borderColor: "darkgreen" },
                }}>
                  {t("Annulla")}
                </Button>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <Button variant="contained" color="info" onClick={handleOpenModal} sx={{
                  margin:"10px 0 0 0",
                  height: '35px',
                  color:WHITE,
                  backgroundColor: GREEN_LOGO,
                  "&:hover": { backgroundColor: "darkgreen" },
                  border: "1px solid " + GREEN_LOGO,
                }}>
                  {t("Salva")}
                </Button>
              </Grid>
            </Grid>
          )
        )}


        {mainError && <>
            <Typography
              variant="body2" // Tipo di testo
              color="error"   // Colore rosso per il messaggio di errore
              sx={{
                maxHeight: '6.5em',        // Limite massimo di altezza per circa 5 righe (1.3em per linea)
                overflow: 'hidden',        // Nasconde l'overflow
                textOverflow: 'ellipsis',  // Aggiunge i puntini di sospensione se il testo è troppo lungo
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 5,        // Limita il numero massimo di righe a 5
                lineHeight: '1.3em',       // Altezza della riga per calcolare il numero di righe
                wordWrap: 'break-word',    // Va a capo automaticamente
                paddingTop:'20px'
              }}
            >
            {mainErrorMex}
          </Typography>
        </>
        }

      <AlertSaveModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSave={handleSave}
      />

      {/* Popup che appare dopo il salvataggio */}
      <Snackbar open={showPopup} anchorOrigin={{vertical: 'bottom', horizontal: "right" }}>
        <Alert severity="success"
          sx={{ 
            border: '2px solid green',
            marginBottom:'30px'
          }}
          onClose={() => setShowPopup(false)}>
          {t("Salvataggio dati avvenuto con successo")}
        </Alert>
      </Snackbar>
    </Box>
  );
};


export default AssociationOrCompanyUser;
